import React from "react";
import StatsCard from "../../Components/UI/staticsCard";
import DollarSignIcon from "../Common/svg/reports/dollarsign";
import PaymentCardIcon from "../Common/svg/paymentCard";
import ClockIcon from "../Common/svg/reports/clockicon";
import ErrorIcon from "../Common/svg/messages/error";
import StatusBadge from "../orders/show/statusbadge";
import { formatPrice } from "../../utils/formatPrice";
import CustomerInfo from "./customerInfo";
import StoreInfo from "./storeInfo";
import CurioerInfo from "./curioerInfo";
import ShowIcon from "../Common/svg/showIcon";
import { useNavigate } from "react-router-dom";

const OrderHeader = ({ orderData, isMultiStore }) => {
  const navigate = useNavigate();
  const order = orderData?.data?.order;

  if (!order) {
    return (
      <div className="card mb-3 rounded-4">
        <div className="card-body">
          <div className="text-center text-muted py-3">
            لا توجد بيانات طلب متاحة
          </div>
        </div>
      </div>
    );
  }

  // Dynamic data configuration for order stats
  const orderStatsConfig = [
    {
      title: "إجمالي الطلب",
      count: `${formatPrice(order.pricing.currency_factor, order.pricing?.total_amount)} ${order.pricing?.symbol_currency || ""}`,
      color: "#1DBF73",
      icon: <DollarSignIcon />,
      bgIcon: "#F0FDF9",
    },
    {
      title: "طريقة الدفع",
      count: order.payment_method?.name || "غير محدد",
      color: "#3F5568",
      icon: <PaymentCardIcon />,
      bgIcon: "#E7EAEC",
    },
    {
      title: "وقت الإنشاء",
      count: order.created_at
        ? new Date(order.created_at).toLocaleString()
        : "--",
      color: "#FF9500",
      icon: <ClockIcon />,
      bgIcon: "#FFF7ED",
    },
    {
      title: "حالة الدفع",
      count: order.payment_status?.label || "غير مدفوع",
      color: order.payment_status?.value === "paid" ? "#1DBF73" : "#FF3B30",
      icon: <ErrorIcon />,
      bgIcon: order.payment_status?.value === "paid" ? "#F0FDF9" : "#FDEAE9",
    },
  ];

  const showorderPage = (id) => {
    navigate(`${process.env.PUBLIC_URL}/orders/${id}`);
  };

  return (
    <div className="card mb-3 rounded-4">
      <div className="card-body ">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div>
            <h5 className="fw-bold d-inline-block">رقم الطلب: </h5>
            <span className="text-success fw-bold">{order.order_number}</span>

            <div className="mt-2">
              <StatusBadge
                status={order.status?.value}
                statusLabel={order.status?.label}
              />
            </div>

            <div className="mt-2">
              <span className="badge bg-primary">{order.type?.value}</span>
              {order.priority && (
                <span className="badge bg-warning ms-2">{order.priority}</span>
              )}
            </div>
          </div>

          <div className="d-flex flex-column align-items-end gap-2">
            <button
              data-tooltip-id="show"
              className="btn btn-sm btn-primary"
              onClick={() => showorderPage(order.id)}
            >
              عرض الطلب
            </button>
            <div className="d-flex gap-2">
              <span className="badge bg-info">
                رقم المرجع: {order.reference_code}
              </span>
            </div>
            {order.note && (
              <div className="mt-2 text-muted small">ملاحظة: {order.note}</div>
            )}
          </div>
        </div>
        <div className="row">
          {orderStatsConfig.map((stat, index) => (
            <div className="col-md-3 col-lg-6" key={index}>
              <StatsCard {...stat} />
            </div>
          ))}
        </div>
        <div className="row">
          <CustomerInfo orderData={orderData} />
          {isMultiStore && <StoreInfo orderData={orderData} />}
          <CurioerInfo orderData={orderData} />
        </div>
      </div>
    </div>
  );
};

export default OrderHeader;
